'use strict';

var _flickity = require('./flickity.provider');

var _flickity2 = require('./flickity.service');

var _flickity3 = require('./flickity.directive');

var _flickityNext = require('./next/flickityNext.directive');

var _flickityPrevious = require('./previous/flickityPrevious.directive');

angular.module('bc.Flickity', []).provider('FlickityConfig', _flickity.FlickityConfigProvider).service('FlickityService', _flickity2.FlickityService).directive('bcFlickity', _flickity3.FlickityDirective).directive('bcFlickityNext', _flickityNext.FlickityNextDirective).directive('bcFlickityPrevious', _flickityPrevious.FlickityPreviousDirective);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/